import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { fontWeights, typographyMixin } from "../../../design-system/tokens/typography";

/** GAP: 14px padding, no spacing token. */
const PAD = "0.875rem";

export const Bar = styled.nav`
  display: flex;
  align-items: stretch;
  width: 100%;
  height: ${spacing[10]};
  box-sizing: border-box;
  background: ${rawColors.structural.white};
  border-top: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  color: ${rawColors.text.highEmphasis};
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const AddButton = styled.button`
  appearance: none;
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  margin: 0;
  padding: 0 ${PAD};
  border: none;
  background: none;
  white-space: nowrap;
  ${typographyMixin("caption", 2)}
  color: ${rawColors.text.interactive};
  cursor: pointer;

  &[aria-disabled="true"] {
    color: ${rawColors.grey[500]};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: ${borderWidth[2]} solid ${rawColors.primary[500]};
    outline-offset: -${borderWidth[2]};
  }
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const Meta = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0 ${PAD};
  border-left: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  white-space: nowrap;
  ${typographyMixin("caption", 4)}
  font-size: 0.6875rem; /* GAP: 11px, no token */
  color: ${rawColors.text.lowEmphasis};
`;

export const EditCell = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${spacing[2]};
  border-right: ${borderWidth[1]} solid ${rawColors.stroke[200]};
`;

export const EditInput = styled.input`
  width: 9rem;
  padding: ${spacing[1]} ${spacing[2]};
  border: ${borderWidth[1]} solid ${rawColors.primary[500]};
  border-radius: ${borderRadius[5]};
  ${typographyMixin("caption", 2)}
  color: ${rawColors.text.highEmphasis};
  background: ${rawColors.structural.white};

  &:focus-visible {
    outline: ${borderWidth[2]} solid ${rawColors.primary[500]};
  }
`;

export const MenuCell = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${spacing[1]};
  border-right: ${borderWidth[1]} solid ${rawColors.stroke[200]};
`;
